module.exports = __webpack_public_path__ + "download_mac_badge.ff5340f.png";